// extracted by mini-css-extract-plugin
export default {"root":"TaskBarContainer_root__Ms4Be"};